const _ = require('lodash');

module.exports = {
  tags_type_count_$gte: function(type, value) {
    return {
      tags: {
        $where: {
          type: type
        },
        $having: {
          count: {
            $gte: value
          }
        }
      }
    }
  },
  tags_type_count_$lte: function(type, value) {
    return {
      tags: {
        $where: {
          type: type
        },
        $having: {
          count: {
            $lte: value
          }
        }
      }
    }
  },
  $aggregations_distance: function(distance = {}, relation = '') {
    const fromParams = _.pick(distance, ['latitude', 'longitude']);
    const hasDistanceQuery = Object.keys(fromParams).length === 2;

    return hasDistanceQuery ? [
      {
        alias: 'distance',
        relation: relation,
        type: 'distance',
        from: fromParams
      }
    ] : undefined;
  },
  $aggregation_distance: function(distance = {}, relation = '') {
    const fromParams = _.pick(distance, ['latitude', 'longitude']);
    const hasDistanceQuery = Object.keys(fromParams).length === 2;

    return hasDistanceQuery ? {
      alias: 'distance',
      relation: relation,
      type: 'distance',
      from: fromParams
    } : undefined;
  }
}
